module.exports = __webpack_public_path__ + "static/media/Y_E_S_P_L_Z_black.59710129.svg";